var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notification-email" },
    [
      _c("CompassObject", {
        attrs: { size: "small", type: "object", object: "inbox-email" }
      }),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "typographies-paragraph-medium-semibold" }, [
          _vm._v("\n            " + _vm._s(_vm.getText.label) + "\n        ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "typographies-paragraph-medium-regular" }, [
          _vm._v("\n            " + _vm._s(_vm.getText.subject) + "\n        ")
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }